import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { PagedData } from '../models/paging/paged-data';
import { Page } from '../models/paging/page';
import { ServerData } from '../models/paging/server-data';

import { SnotifyService } from 'ng-snotify';
import { environment } from '../../environments/environment';
import { WebUser } from '../models/web_User';
import { WebUserType } from '../models/web_User_Type';
import { Guid } from 'guid-typescript';
import { e } from '@angular/core/src/render3';


@Injectable()
export class WebUserService {
  constructor(private http: HttpClient, private snotifyService: SnotifyService) { }


  /*public getAll(company_Id: number): Promise<Location[]> {
    console.log(environment.apiUrl + 'location/getall?company_Id=' + company_Id);
    const headers = {
      'Content-Type': 'application/json',
    };
    return new Promise((resolve, reject) => {
      this.http.get<Location[]>(environment.apiUrl + 'webUser/getall?company_Id=' + company_Id, { headers: headers }).subscribe(data => {
        resolve(data);
      }, error => {
        console.log(error);
        reject();
      });
    });
  }*/

  public get(user_Id: number): Promise<WebUser> {
    return new Promise((resolve, reject) => {
      console.log(user_Id);
      this.http.get<WebUser>(environment.apiUrl + 'webUser/get?user_Id=' + user_Id).subscribe(data => {
        resolve(data);
      }, error => {
        console.log(error);
        reject();
      });
    });
  }

  public getAllUserTypes(): Promise<WebUserType[]> {

    return new Promise((resolve, reject) => {
      this.http.get<WebUserType[]>(environment.apiUrl + 'webUser/getAllUserTypes').subscribe(data => {
        resolve(data);
      }, error => {
        console.log(error);
        resolve(null)
      });
    });
  }

  public save(webUser: WebUser): Promise<any> {

    webUser.company_Id = Number(webUser.company_Id);
    webUser.user_Type_Id = Number(webUser.user_Type_Id);

    if (webUser.user_Id == '') {
      webUser.user_Id = Guid.createEmpty().toString();
    }

    if (webUser.company_Id == 0) {
      this.snotifyService.error('Please select a company');
      return;
    }

    if (webUser.password != webUser.confirmPassword) {
      this.snotifyService.error("Password doesn't match. Please ensure both passwords are identical", { timeout: 8000 });
      return;
    }

    if (webUser.email != webUser.confirmEmail) {
      this.snotifyService.error("Email doesn't match. Please ensure both emails are identical", { timeout: 8000 });
      return;
    }

    return new Promise((resolve, reject) => {
      console.log(webUser);
      if (webUser.is_edit) {
        this.http.put<any>(environment.apiUrl + 'webUser/put', webUser).subscribe(data => {
          resolve(data);
          if (data.success) {
            this.snotifyService.success('Successfully edited user');
          }
          else {
            switch (data.message) {
              case "Email":
                this.snotifyService.error('Email already exists', { timeout: 4000 });
                break;
              case "Password":
                this.snotifyService.error('Password failed to save', { timeout: 4000 });
                break;
                case "Password_empty":
                  this.snotifyService.error(`Password can't be empty`, { timeout: 4000 });
                  break;
                case "Password_not_long":
                  this.snotifyService.error(`Password should be a minimum of 12 characters long`, { timeout: 4000 });
                  break;
                case "Password_no_digits":
                  this.snotifyService.error(`Password must at least contain one digit`, { timeout: 4000 });
                  break;
                case "Password_no_chars":
                  this.snotifyService.error(`Password must include special characters`, { timeout: 4000 });
                  break;  
                default:
                  this.snotifyService.error('Failed to edit user', { timeout: 4000 });
                  break;
            }
          }
        }, error => {
          console.log(error);
          reject();
        });
      } else {
        webUser.last_Login_Date = "1970-01-01T00:00:00";
        this.http.post<any>(environment.apiUrl + 'webUser/post', webUser).subscribe(data => {
          resolve(data);
          console.log(data);
          if (data.success) {
            this.snotifyService.success('Successfully added user');
          }
          else {
            console.log("put request data", data);
            
            switch (data.message) {
              case "Email":
                this.snotifyService.error('Email already exists', { timeout: 4000 });
                break;
              case "Password":
                this.snotifyService.error('Password failed to save', { timeout: 4000 });
                break;
              case "Password_empty":
                this.snotifyService.error(`Password can't be empty`, { timeout: 4000 });
                break;
              case "Password_not_long":
                this.snotifyService.error(`Password should be a minimum of 12 characters long`, { timeout: 4000 });
                break;
              case "Password_no_digits":
                this.snotifyService.error(`Password must at least contain one digit`, { timeout: 4000 });
                break;
              case "Password_no_chars":
                this.snotifyService.error(`Password must include special characters`, { timeout: 4000 });
                break;
              default:
                this.snotifyService.error('Failed to add user', { timeout: 4000 });
                break;
            }
          }

        }, error => {
          console.log(error);
          reject();
        });
      }
    });
  }


  public getResults(page: Page, username: string, company_Id: number, email: string, quick_Search: string): Promise<PagedData<WebUser>> {
    const pagedData = new PagedData<WebUser>();

    return new Promise((resolve, reject) => {
      if (page.sortBy == undefined || page.sortBy == '') { page.sortBy = 'FirstName'; }
      if (page.sortOrder == undefined || page.sortOrder == '') { page.sortOrder = 'asc'; }

      let params = '&username=' + username;
      params += '&company_Id=' + company_Id;
      params += '&email=' + email;
      params += '&quick_Search=' + quick_Search;

      this.http.get<ServerData>(environment.apiUrl + 'webUser/getTable?size=' + page.size + '&pageNumber=' + page.pageNumber + '&sortBy=' + page.sortBy + '&sortOrder=' + page.sortOrder + params).subscribe(data => {
        page.totalElements = data.total;
        page.totalPages = page.totalElements / page.size;
        for (let i = 0; i < data.data.length; i++) {
          const jsonObj = data.data[i];
          pagedData.data.push(jsonObj);
        }

        pagedData.page = page;
        resolve(pagedData);

      }, error => {
        reject();
      });
    });
  }

  public getExcel(page: Page, username: string, company_Id: number): Promise<any> {
    return new Promise((resolve, reject) => {

      let params = '?username=' + username;
      params += '&company_Id=' + company_Id;

      this.http.get<any>(environment.apiUrl + 'webUser/getExcel' + params).subscribe(data => {
        let blob = this.converBase64toBlob(data, 'application/vnd.ms-excel');
        resolve(blob);
      }, error => {
        console.log(error);
        reject();
      });
    });
  }



  converBase64toBlob(content, contentType) {
    contentType = contentType || '';
    let sliceSize = 512;
    let byteCharacters = window.atob(content); //method which converts base64 to binary
    let byteArrays = [
    ];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      let slice = byteCharacters.slice(offset, offset + sliceSize);
      let byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      let byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    let blob = new Blob(byteArrays, {
      type: contentType
    }); //statement which creates the blob
    return blob;
  }
}
